import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { BoardMemberProvider } from './context/BoardMemberProvider.tsx'
import { EventManagerProvider } from './context/EventManagerProvider.tsx'
import { SiteAuthProvider } from './context/SiteAuthContext.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SiteAuthProvider>
      <BoardMemberProvider>
        <EventManagerProvider>
          <App />
        </EventManagerProvider>
      </BoardMemberProvider>
    </SiteAuthProvider>
  </StrictMode>,
)
